import { Box, FormControl } from '@mui/material';
import {
  AppUser,
  useAppDispatch,
  useAppSelector,
  useGetAllUsersQuery,
} from 'api';
import { setSelectedUser } from 'api/models/userMaintenance';
import { AutocompleteField } from 'app/common/autocomplete';
import { matchSorter } from 'match-sorter';
import { useMemo } from 'react';

const defaultUser: AppUser = {
  id: 0,
  firstName: '',
  lastName: '',
  displayName: '',
  isAdmin: false,
  authTimestamp: 0,
  authTimeoutTimestamp: 0,
  email: '',
  userName: '',
  status: '',
};

export const UserMaintenanceAutoComplete = () => {
  const dispatch = useAppDispatch();
  const { data: users } = useGetAllUsersQuery();
  const { selectedUser } = useAppSelector(state => state.userMaintenance);
  const activeUsers = useMemo(
    () => users?.filter(u => u.status === 'ACTIVE' || u.status === 'RECOVERY'),
    [users]
  );
  const displayedUsers = useMemo(() => activeUsers || [defaultUser], [activeUsers]);

  const filterOptions = (options: AppUser[], { inputValue }: any) =>
    matchSorter(options, inputValue, {
      keys: ['email', 'displayName', 'firstName', 'lastName', 'userName'],
      threshold: matchSorter.rankings.CONTAINS,
    });

  const handleAutocompleteChange = (
    newValue: string | AppUser | null
  ): boolean => {
    if (newValue === null) {
      dispatch(setSelectedUser(null));
      return false;
    } else if (typeof newValue === 'string') {
      return false;
    } else if (newValue && newValue.id) {
      const user = users?.find(u => u.id === newValue.id);
      dispatch(setSelectedUser(user || null));
      return false;
    }

    return false;
  };
  return (
    <Box
      width="600px"
      padding="20px"
      display="flex"
      alignItems="center"
      gap="10px"
      margin="auto"
    >
      <FormControl fullWidth>
        <AutocompleteField<AppUser>
          nameLabel="user"
          optionKeys={['displayName', 'email', 'userName']}
          selectedValue={selectedUser}
          displayOptions={displayedUsers}
          handleAutocompleteChange={handleAutocompleteChange}
          handleFilterOptions={filterOptions}
          allowCreate={false}
          handleCreateNewItem={null}
          newItemValue={null}
          handleNewItemValueChange={null}
        />
      </FormControl>
    </Box>
  );
};
